export default __webpack_public_path__ + "static/media/new.8b5eb6b6.gif";